define([
    './defined',
    './defaultValue',
    '../System/Vec3Obj'
], function (
    defined,
    defaultValue,
    Vec3Obj
) {
    'use strict'

    /**
     * 将一定规则的字符串转成基础类型数组，用于对象还原。
     *
     * @private
     *
     * @exports string2NumberArray
     */
    const string2NumberArray = (str, sp1) => {
        let splitStr1 = defaultValue(sp1, ";")
        let result = []

        // 拆分成每个对象的字符串
        let objStrings = str.split(splitStr1)

        for (let i = 0; i < objStrings.length; ++i) {
            if (objStrings[i].trim() === "") continue; // 跳过空字符串
            result.push(objStrings[i])
        }
        return result
    }
    return string2NumberArray
});
